import type { Placement } from '@floating-ui/react'
import type { CSSProperties, FC } from 'react'
import type { SelectableListProps } from './selectable-list'
import { SelectableList } from './selectable-list'
import { Modal } from '../../modal'

export interface SelectableListModalProps {
    anchor: HTMLElement
    selectableListProps: SelectableListProps
    onClose?(): void
    placement?: Placement
    onBack?(): void
    containerStyle?: CSSProperties
    style?: CSSProperties
}

export const SelectableListModal: FC<SelectableListModalProps> = ({
    anchor,
    selectableListProps,
    onClose,
    placement,
    onBack,
    containerStyle,
    style,
}) => {
    return (
        <Modal
            anchor={anchor}
            style={style ?? { width: '500px' }}
            placement={placement}
            onClose={onClose}
            onBack={onBack}
            containerStyle={containerStyle}>
            <SelectableList
                {...selectableListProps}
                onQueryChange={(query) => {
                    selectableListProps.onQueryChange?.(query)
                }}
            />
        </Modal>
    )
}
